module.exports = __webpack_public_path__ + "img/widget_005.1d7902d0.png";